import { OVERLAY_KINDS, OVERLAY_LIFECYCLE_EVENTS, OVERLAY_PHASES } from './overlay_lifecycle_events'

const now = function () {
	if (typeof performance !== 'undefined' && performance.now) {
		return performance.now()
	}
	return Date.now()
}

const createInitialState = function (kind) {
	return {
		kind: kind,
		phase: OVERLAY_PHASES.HIDDEN,
		transitionId: 0,
		id: null,
		type: null,
		link: null,
		title: null,
		startedAt: 0,
		updatedAt: 0,
	}
}

const cloneState = function (state) {
	return Object.assign({}, state)
}

const emitLifecycleEvent = function (eventName, detail) {
	if (typeof window === 'undefined') {
		return
	}

	if (window.laytheme && typeof window.laytheme.emit === 'function') {
		window.laytheme.emit(eventName, detail)
	}

	if (typeof window.dispatchEvent === 'function' && typeof CustomEvent !== 'undefined') {
		window.dispatchEvent(new CustomEvent('lay:' + eventName, { detail: detail }))
	}
}

const emitPhaseChanged = function (state, previousState = null, sourceEvent = null) {
	const detail = cloneState(state)
	if (previousState) {
		detail.previousPhase = previousState.phase
		detail.previousTransitionId = previousState.transitionId
	}
	if (sourceEvent) {
		detail.sourceEvent = sourceEvent
	}
	const eventName =
		state.kind == OVERLAY_KINDS.PROJECT
			? OVERLAY_LIFECYCLE_EVENTS.PROJECT_PHASE_CHANGED
			: OVERLAY_LIFECYCLE_EVENTS.PAGE_PHASE_CHANGED

	emitLifecycleEvent(eventName, detail)
	emitLifecycleEvent(OVERLAY_LIFECYCLE_EVENTS.PHASE_CHANGED, detail)
}

const getJQueryElement = function ($element) {
	if (!$element) return null
	if ($element.jquery) return $element
	if (typeof jQuery !== 'undefined') return jQuery($element)
	return null
}

const getFirstDomElement = function ($element) {
	const $jqElement = getJQueryElement($element)
	return $jqElement && $jqElement.length ? $jqElement[0] : null
}

const getDataValue = function ($element, key) {
	const $jqElement = getJQueryElement($element)
	if (!$jqElement || !$jqElement.length || typeof $jqElement.attr !== 'function') return null
	return $jqElement.attr('data-' + key) || null
}

const isOpenPhase = function (phase) {
	return (
		phase == OVERLAY_PHASES.LOADING ||
		phase == OVERLAY_PHASES.OPENING ||
		phase == OVERLAY_PHASES.VISIBLE ||
		phase == OVERLAY_PHASES.CLOSING ||
		phase == OVERLAY_PHASES.DESTROYING
	)
}

const startsNewTransition = function (currentState, nextPhase) {
	if (currentState.phase == OVERLAY_PHASES.HIDDEN && isOpenPhase(nextPhase)) return true
	if (currentState.phase == OVERLAY_PHASES.VISIBLE && nextPhase == OVERLAY_PHASES.CLOSING) return true
	if (currentState.phase == OVERLAY_PHASES.VISIBLE && nextPhase == OVERLAY_PHASES.LOADING) return true
	return false
}

const shouldEmit = function (currentState, nextState) {
	return (
		currentState.phase != nextState.phase ||
		currentState.transitionId != nextState.transitionId ||
		currentState.id != nextState.id ||
		currentState.type != nextState.type ||
		currentState.link != nextState.link ||
		currentState.title != nextState.title
	)
}

const buildNextState = function (currentState, nextPhase, meta, transitionId, clearMeta) {
	const timestamp = now()
	const nextStartedAt = startsNewTransition(currentState, nextPhase) ? timestamp : currentState.startedAt
	const state = {
		kind: currentState.kind,
		phase: nextPhase,
		transitionId: transitionId,
		id: clearMeta ? null : meta.id || currentState.id,
		type: clearMeta ? null : meta.type || currentState.type,
		link: clearMeta ? null : meta.link || currentState.link,
		title: clearMeta ? null : meta.title || currentState.title,
		startedAt: nextStartedAt,
		updatedAt: timestamp,
	}

	if (nextPhase == OVERLAY_PHASES.HIDDEN) {
		state.startedAt = 0
	}

	return state
}

const installOverlayLifecyclePublicApi = function () {
	if (typeof window === 'undefined' || !window.laytheme) return

	window.laytheme.isAnyOverlayOpen = function () {
		const projectOpen =
			typeof window.laytheme.isProjectOverlayOpen === 'function' ? window.laytheme.isProjectOverlayOpen() : false
		const pageOpen = typeof window.laytheme.isPageOverlayOpen === 'function' ? window.laytheme.isPageOverlayOpen() : false

		return projectOpen || pageOpen
	}

	window.laytheme.getOverlayLifecycleState = function () {
		const project =
			typeof window.laytheme.getProjectOverlayState === 'function' ? window.laytheme.getProjectOverlayState() : null
		const page = typeof window.laytheme.getPageOverlayState === 'function' ? window.laytheme.getPageOverlayState() : null

		return {
			project: project,
			page: page,
			anyOpen: window.laytheme.isAnyOverlayOpen(),
		}
	}
}

export {
	buildNextState,
	cloneState,
	createInitialState,
	emitPhaseChanged,
	getDataValue,
	getFirstDomElement,
	installOverlayLifecyclePublicApi,
	isOpenPhase,
	shouldEmit,
	startsNewTransition,
}
